module.exports = __webpack_public_path__ + "img/zu5.5adb221d.png";